import { Block } from "common/types/graphql"
import { BlocksRenderer } from "../BlocksRenderer"

export interface ListProps {
  ordered: boolean
  blocks?: Block[]
  items?: string[]
}

export const List = ({ ordered, blocks, items }: ListProps) => {
  let listItems

  if (items) {
    listItems = items.map((item, index) => <li key={index}>{item}</li>)
  } else if (blocks) {
    listItems = blocks.map((block, index) => (
      <li key={index}>
        <BlocksRenderer blocks={block.props.blocks} />
      </li>
    ))
  }

  return ordered ? (
    <ol className="mb-4 max-w-(--breakpoint-lg) list-outside list-decimal space-y-3 pl-5 font-serif lg:text-xl">
      {listItems}
    </ol>
  ) : (
    <ul className="mb-4 max-w-(--breakpoint-lg) list-outside list-disc space-y-3 pl-5 font-serif lg:text-xl">
      {listItems}
    </ul>
  )
}
